/**
 * 检查当前域名是否为生产环境
 * @returns {boolean} 如果当前域名不是 gk.duyangsong.cn 返回 true（需要显示水印），否则返回 false
 */
export const shouldShowWatermark = (): boolean => {
  return window.location.hostname !== 'gk.duyangsong.cn'
}